import { CwUtils } from 'cw-utils';

import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { Fee } from '../../../models/backend-definitions.module';
import { PageOptions } from '../../../util/backend-util-module';

@Injectable()
export class FeeListProvider implements Resolve<any> {
    fee: Fee[];
    feeEdit: Fee;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.feeEdit = this.state?.currentFee;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Fee> {
        if (!id) {
            return null;
        }
        return this.gw.get('fee/:id', { id: id });
    }

    get currentFee(): Fee {
        return this.feeEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('fee/').subscribe((res: HttpResponse<any>) => {
                this.fee = res.body;
                this.onDataChanged.next(this.fee);
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('fee/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.fee, res.body.content) && res.body.content.length > 0) {
                    this.fee = res.body.content;
                    this.onDataChanged.next(this.fee);
                } else {
                    this.fee = res.body.content;
                }
                resolve(res);
            }, reject);
        });
    }

    getFeeType(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('fee/feeType/simpleList')
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

